<template>
  <div>
    <MemberLayout>
      <div class="container">
        <div class="row">
          <div class="col-5">
            <select v-model="searchMonth" class="form-control">
              <option value disabled>請選擇查詢月份</option>
              <option
                v-for="month in searchMonthList"
                :value="month.value"
                :key="month.value"
              >
                {{ month.label }}
              </option>
            </select>
          </div>
          <div class="col-5">
            <select v-model="queryStartLevel" class="form-control">
              <option :value="1">1~4層</option>
              <option :value="5">5~8層</option>
              <option :value="9">9~12層</option>
            </select>
          </div>
          <div class="col-2">
            <button
              class="btn btn-primary btn-block"
              @click="changeSearchMonth"
            >
              查詢組織圖
            </button>
          </div>
          <div class="col-12">
            <p class="m-0" style="height: 48px">
              使用說明：選擇欲查詢月份、層數後，按下「查詢組織圖」按鈕後，即可顯示組織圖。待組織圖顯示後，可以透過上下與左右方向卷軸移動來觀看組織圖內容。
            </p>
          </div>
        </div>
      </div>
      <div v-if="'SEQ' in hierarchyParams">
        <iframe class="hierarchy-iframe" :src="iframeURL" ref="iframe"></iframe>
      </div>
      <b-modal id="controlModal" title="請選擇下一步" hide-footer>
        <template>
          <button class="btn btn-primary btn-block" @click="showDetail">
            顯示該員資料
          </button>
          <button class="btn btn-primary btn-block" @click="showSubHierarchy">
            顯示該員組織圖
          </button>
        </template>
      </b-modal>

      <b-modal id="detailModal" title="詳細資料" hide-footer>
        <template>
          <div v-if="!detailLoaded">
            <h4>詳細資料載入中，請稍候</h4>
          </div>
          <div v-if="detailLoaded">
            <div>
              <h4>基本資訊</h4>
              <p>營業月份：{{ customer.MRESULTS }}</p>
              <p class="mb-0">組織報表更新時間：{{ customer.CDATE }}</p>
              <hr />
            </div>
            <div>
              <h4>會員資訊</h4>
              <p>會員ID：{{ customer.JPSEQ }}</p>
              <p>會員姓名： {{ customer.NAME }}</p>
              <p>定期OK： {{ customer.ACT }}</p>
              <p>會員別： {{ customer.courseName }}</p>
              <p>職稱： {{ customer.positionName }}</p>
              <p>聘階： {{ customer.rankName }}</p>
              <p>入會日期： {{ customer.REGISTDATE }}</p>
              <p>推薦人ID： {{ hideId(customer.INTROSEQ) }}</p>
              <p>推薦人姓名：{{ introName }}</p>
              <p>安置人ID： {{ hideId(customer.UPLINE) }}</p>
              <p>首購PV： {{ getNumberWithCommas(customer.INTROPOINT) }}</p>
              <p>定期PV： {{ getNumberWithCommas(customer.REPEATPOINT) }}</p>
              <p>加購PV： {{ getNumberWithCommas(customer.ADDPOINT) }}</p>
              <p>第1層PV數： {{ getNumberWithCommas(customer.LBL1PV) }}</p>
              <p>第2層PV數： {{ getNumberWithCommas(customer.LBL2PV) }}</p>
              <p>第3層PV數： {{ getNumberWithCommas(customer.LBL3PV) }}</p>
              <p>3層內PV數： {{ getNumberWithCommas(customer.L3PVF) }}</p>
              <p>組職總pv數： {{ getNumberWithCommas(customer.GRPPOINT) }}</p>
              <hr />
            </div>
            <div>
              <h4>組織資訊</h4>
              <p>組職總人數： {{ getNumberWithCommas(customer.GRPCNT) }}</p>
              <p>A會員人數 {{ getNumberWithCommas(customer.GRPCNT_A) }}</p>
              <p>B會員人數 {{ getNumberWithCommas(customer.GRPCNT_B) }}</p>
              <p>C會員人數 {{ getNumberWithCommas(customer.GRPCNT_C) }}</p>
              <p>直接推薦人數 {{ getNumberWithCommas(customer.AB_TOTAL) }}</p>
              <hr />
            </div>
            <div>
              <h4>組織活躍狀態</h4>
              <p>
                組織定期OK的人數：
                {{ getNumberWithCommas(customer.ACTIVEGRPCNT) }}
              </p>
              <p>
                A會員定期OK人數： {{ getNumberWithCommas(customer.ACTIVE_A) }}
              </p>
              <p>
                B會員定期OK人數： {{ getNumberWithCommas(customer.ACTIVE_B) }}
              </p>
              <p>
                直接推薦定期OK人數：
                {{ getNumberWithCommas(customer.AB_ACTIVE_TOTAL) }}
              </p>
              <hr />
            </div>
            <div>
              <h4>3層內狀態</h4>
              <p>第1層定期OK數： {{ getNumberWithCommas(customer.LBL1) }}</p>
              <p>第2層定期OK數： {{ getNumberWithCommas(customer.LBL2) }}</p>
              <p>第3層定期OK數： {{ getNumberWithCommas(customer.LBL3) }}</p>
              <p>
                第1層領導員LD人數： {{ getNumberWithCommas(customer.LBL1LD) }}
              </p>
              <p>
                第1層指導員DR人數： {{ getNumberWithCommas(customer.LBL1DR) }}
              </p>
            </div>
          </div>
        </template>
      </b-modal>

      <b-modal id="subModal" title="成員組織圖" size="xl" hide-footer>
        <template>
          <div v-if="!subLoaded">
            <h4>組織圖載入中，請稍候</h4>
          </div>
          <div v-if="subLoaded">
            <SubHierachy :subSearch="subSearch" />
          </div>
        </template>
      </b-modal>
    </MemberLayout>
  </div>
</template>

<script>
import MemberLayout from "../../components/member/MemberLayout";
import SubHierachy from "../../components/member/SubHierachy";
import { getBusinessMonthList, getCurrentUser } from "../../api/fordaysHelpers";
import { getNumberWithCommas, hideId } from "../../api/fordaysHelpers";
import db from "../../api/db";

// 顯示組織圖的Token
const access_token =
  "207a9537bca52a44cbe777626572a2308371826514db1d70767b708f03c449ea";

export default {
  name: "HierarchyScreen",
  components: {
    MemberLayout,
    SubHierachy,
  },
  computed: {
    iframeURL() {
      const vm = this;
      const hierarchyParams = vm.hierarchyParams;
      const searchMonth = vm.searchMonth;
      const queryStartLevel = vm.queryStartLevel;
      const webviewBody = `SEQ=${hierarchyParams.SEQ}&SEARCHMONTH=${searchMonth}&LEVEL=${hierarchyParams.LEVEL}&MAPID=${hierarchyParams.MAPID}&GRPCNT=${hierarchyParams.GRPCNT}&QUERYSTARTLEVEL=${queryStartLevel}&ACCESS_TOKEN=${access_token}`;
      const url = `${vm.$hostURL}/member/hierarchyv2-web?${webviewBody}`;
      return url;
    },
  },
  data() {
    return {
      searchMonth: "",
      searchMonthList: getBusinessMonthList(),
      access_token: access_token,
      user: {},
      hierarchyParams: {},
      queryStartLevel: 1,
      iframeWin: {},
      subSearchSEQ: "",
      // 詳細資料
      customer: {},
      introName: "",
      detailLoaded: false,
      // 子組織圖
      subLoaded: false,
      subSearch: {
        SEQ: "",
        searchMonth: "",
      },
    };
  },
  methods: {
    async changeSearchMonth() {
      const vm = this;
      const searchMonth = vm.searchMonth;
      const currentUser = vm.user;
      const doc = await db
        // 從JC2map_masterOut集合取得
        .collection("JC2map_masterOut")
        // 一名為SEQ+搜尋營業月份的文件
        .doc(`${currentUser.SEQ}${searchMonth}`)
        .get();
      if (!doc.exists) {
        vm.hierarchyParams = {};
        return;
      }
      let currentUserJC2Map = doc.data();
      // 取得使用者的等級
      const LEVEL = currentUserJC2Map.LEVEL;
      // 取得使用者的MAPID
      const MAPID = currentUserJC2Map.MAPID;
      // 取得使用者的GRPCNT
      const GRPCNT = currentUserJC2Map.GRPCNT;

      vm.hierarchyParams = {
        SEQ: currentUser.SEQ,
        LEVEL: LEVEL,
        MAPID: MAPID,
        GRPCNT: GRPCNT,
      };
      setTimeout(() => {
        vm.iframeWin = vm.$refs.iframe.contentWindow;
      }, 2000);
    },
    handleIFramePostMessage(event) {
      const vm = this;
      if (event.origin.startsWith(vm.$hostURL)) {
        const subSearchSEQ = event.data;
        vm.subSearchSEQ = subSearchSEQ;
        vm.$bvModal.show("controlModal");
      }
    },
    showDetail() {
      const vm = this;
      const subSearchSEQ = vm.subSearchSEQ;
      const searchMonth = vm.searchMonth;
      // window.sessionStorage.setItem("subSearchSEQ", JSON.stringify(subSearch));
      // vm.$router.push("/member/hierarchy/detail");
      vm.detailLoaded = false;
      vm.$bvModal.show("detailModal");
      vm.$bvModal.hide("controlModal");
      fetchData();
      async function fetchData() {
        let doc = await db
          .collection("JC2map_masterOut")
          .doc(`${subSearchSEQ}${searchMonth}`)
          .get();
        let customer = doc.data();

        // 取得會員別文件
        let courseDoc = await db
          .collection("jqualificationtypeout")
          .doc(`${customer.COURSE}`)
          .get();
        customer.courseName = "";
        if (courseDoc.exists) {
          customer.courseName = courseDoc.data().NAME;
        }

        // 設定職稱
        customer.positionName = "";
        if (customer.POSITION == 0) {
          customer.positionName = "無";
        } else if (customer.POSITION == 1) {
          customer.positionName = "DR";
        } else {
          customer.positionName = "LD";
        }

        // 取得聘階文件
        customer.rankName = "";
        let rankDoc = await db
          .collection("jranktypeout")
          .doc(`${customer.RANK}`)
          .get();

        if (rankDoc.exists) {
          customer.rankName = rankDoc.data().NAME;
        }
        // 取得推薦人ID
        const introSEQ = customer["INTROSEQ"];
        // 取得推薦人文件
        let introDoc = await db.doc(`jcustomerout/${introSEQ}`).get();
        let introName = "";
        // 如果文件存在
        if (introDoc.exists) {
          introName = introDoc.data().NAME;
        }
        vm.customer = customer;
        vm.introName = introName;
        vm.detailLoaded = true;
      }
    },
    showSubHierarchy() {
      const vm = this;
      // 原設計
      // const subSearchSEQ = vm.subSearchSEQ;
      // const subSearch = {
      //   SEQ: subSearchSEQ,
      //   searchMonth: vm.searchMonth,
      // };
      // window.sessionStorage.setItem("subSearchSEQ", JSON.stringify(subSearch));
      // vm.$router.push("/member/hierarchy/sub");
      // 新設計
      vm.$bvModal.hide("subModal");
      vm.subLoaded = false;
      vm.subSearch = {
        SEQ: "",
        searchMonth: "",
      };
      vm.subSearch = {
        SEQ: vm.subSearchSEQ,
        searchMonth: vm.searchMonth,
      };
      vm.subLoaded = true;
      vm.$bvModal.hide("controlModal");
      vm.$bvModal.show("subModal");
    },
    getNumberWithCommas(val) {
      return getNumberWithCommas(val);
    },
    hideId(val) {
      return hideId(val);
    },
  },
  mounted() {
    const vm = this;
    window.addEventListener("message", vm.handleIFramePostMessage);
    fetchData();
    async function fetchData() {
      // 取得目前使用者
      const currentUser = await getCurrentUser();
      vm.user = currentUser;
    }
  },
};
</script>
<style scoped>
.hierarchy-iframe {
  width: 100%;
  border: none;
  /* height: calc(100vh - 112px - 41px - 50px - 25px); */
  height: calc(100vh - 160px - 48px);
  overflow-y: scroll; /* Show vertical scrollbar */
  overflow-x: scroll; /* Show horizontal scrollbar */
}
</style>